import {EEnvironment} from "platform_common/lib/Environment";

class LocalConfig {

    /**
     * Configuration Properties Available ------------------------------------------------------------------
     */
    public PackageName:string = "front_end_client";

    // environment for code
    public Environment:EEnvironment;

    // internal api details
    public APIInternalPort!:number;
    public APIInternalBaseDomain!:string;
    public APIInternaTransport!:string;
    public APIInternalBasePathPrefix:string = '/api/private';

    // debug
    public DebugEnabled:boolean = false;
    public Debug:string = '*';

    constructor() {
        // /set relevant config variables based on environment
        switch (process.env.REACT_APP_ENVIRONMENT) {

            case "live":
                this.Environment = EEnvironment.Live;
                this.setLive();
                break;
            case "localhost":
                this.Environment = EEnvironment.Localhost;
                this.setLocalhost();
                break;
            case "dev":
            default:
                this.Environment = EEnvironment.Dev;
                this.setDev();
                break;
        }
    }

    /**
     * Set  configuration for live
     */
    private setLive() {
        // internal api details
        this.APIInternalPort = 443;
        this.APIInternalBaseDomain = 'frosty-jang-e884e2.netlify.app';
        this.APIInternaTransport = 'https';
    }

    /**
     * Set configuration for localhost
     */
    private setLocalhost() {
        // internal api details
        this.APIInternalPort = 8080;
        this.APIInternalBaseDomain = 'localhost';
        this.APIInternaTransport = 'http';
    }

    /**
     * Set configuration for development
     */
    private setDev() {
        // internal api details
        this.APIInternalPort = 8080;
        this.APIInternalBaseDomain = 'localhost';
        this.APIInternaTransport = 'http';
    }

}

export const Config:LocalConfig = new LocalConfig();
